import apiClient from '@/services/axios'
import store from 'store'

export const getTags = (channelId, params) => {
  const locale = store.get('app.settings.locale') || 'id'
  const lang = locale.split('-')[0]

  return apiClient({
    method: 'GET',
    url: `/channel/distributor/app/product/query/${channelId}/channel-product-tag-languages`,
    params,
    headers: {
      'Accept-Language': lang,
    },
  })
}

export const getTagDetail = (channelId, tagId) => {
  const locale = store.get('app.settings.locale') || 'id'
  const lang = locale.split('-')[0]

  return apiClient({
    method: 'GET',
    url: `/channel/distributor/app/product/query/${channelId}/channel-product-tags/${tagId}`,
    headers: {
      'Accept-Language': lang,
    },
  })
}

export const createTag = (channelId, data) => {
  return apiClient({
    method: 'POST',
    url: `/channel/distributor/app/product/cmd/${channelId}/channel-product-tags`,
    data,
  })
}

export const updateTag = (channelId, tagId, data) => {
  return apiClient({
    method: 'PUT',
    url: `/channel/distributor/app/product/cmd/${channelId}/channel-product-tags/${tagId}`,
    data,
  })
}

export const deleteProductFromTag = (channelId, tagId, productId, catalogId) => {
  return apiClient({
    method: 'DELETE',
    url: `/channel/distributor/app/product/cmd/${channelId}/channel-product-tags/${tagId}/products/${productId}/catalogs/${catalogId}`,
  })
}

export const getProductsInTag = (channelId, tagId, params) => {
  const locale = store.get('app.settings.locale') || 'id'
  const lang = locale.split('-')[0]

  return apiClient({
    method: 'GET',
    url: `/channel/distributor/app/product/query/${channelId}/channel-product-catalog-selected/${tagId}`,
    params,
    headers: {
      'Accept-Language': lang,
    },
  })
}

export const addProductToTag = (channelId, tagId, data) => {
  return apiClient({
    method: 'POST',
    url: `/channel/distributor/app/product/cmd/${channelId}/channel-product-tags/${tagId}/catalogs`,
    data,
  })
}

export const getChannelProducts = (channelId, params) => {
  return apiClient({
    method: 'GET',
    url: `/channel/distributor/product/query/powerbiz/${channelId}`,
    params,
    headers: {
      'Business-Id': params.business_id,
      'Workspace-Id': params.workspace_id,
    },
  })
}
